import {
  PERFORMANCE_COACH_LABEL,
  COLLABORATORS_LABEL,
  MANAGEMENT_LABEL,
} from "../../constants/Dictionary";
import {
  professionalHistoryMenu,
  ProfessionalHistoryMenuEnum,
  professionalHistoryMenuLabels,
} from "../../constants/AppConstants";
import { BreadcrumbItem, PageNames } from "../../types/AppTypes";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { CollaboratorProfileTabs } from "./CollaborProfileTabs/CollaboratorProfileTabs";
import { ExpandMenuOptionItem } from "../../components/ExpandMenu/ExpandMenu";
import { useBreadCrumb } from "../../hooks/useBreadCrumbs.hooks";
import {
  DETAIL_QUERY_PARAM_KEY,
  decodeParams,
  encodeParams,
} from "../../utils/queryParams.utils";

import {
  CollaboratorHistoryApprovalStatus,
  CollaboratorSectionCounter,
} from "../../types/api/collaborators.type";

export const getProfessionalHistoryMenu = (
  isMyProfile: boolean,
  approvalStatusData?: CollaboratorHistoryApprovalStatus | null,
): ExpandMenuOptionItem<ProfessionalHistoryMenuEnum>[] => {
  const hasPending = (count?: CollaboratorSectionCounter) =>
    (count?.pending ?? 0) > 0;

  const notificationMap: Partial<Record<ProfessionalHistoryMenuEnum, boolean>> =
    {
      [ProfessionalHistoryMenuEnum.PROFESSIONAL_PORTRAIT]: hasPending(
        approvalStatusData?.experienceCounts,
      ),
      [ProfessionalHistoryMenuEnum.SKILLS]:
        hasPending(approvalStatusData?.languageSkillCounts) ||
        hasPending(approvalStatusData?.techSkillCounts),

      [ProfessionalHistoryMenuEnum.FORMATION]:
        hasPending(approvalStatusData?.educationCounts) ||
        hasPending(approvalStatusData?.courseCounts) ||
        hasPending(approvalStatusData?.certificationCounts),

      [ProfessionalHistoryMenuEnum.PROJECTS]: hasPending(
        approvalStatusData?.projectCounts,
      ),
    };
  return professionalHistoryMenu.map((item) => ({
    value: item,
    label: professionalHistoryMenuLabels[item],
    hasNotification: isMyProfile ? false : (notificationMap[item] ?? false),
  }));
};

const CollaboratorDetail = () => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const { careerManagerId, collaboratorId } = useParams();

  const queryParams = decodeParams(searchParams.get(DETAIL_QUERY_PARAM_KEY));
  const collaboratorName = queryParams.collaboratorName ?? null;
  const collaboratorSurname = queryParams.collaboratorSurname ?? null;
  const careerManagerName = queryParams.careerManagerName ?? null;
  const careerManagerSurname = queryParams.careerManagerSurname ?? null;

  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    if (pathname.includes(PageNames.CAREER_MANAGER)) {
      return [
        {
          name: PERFORMANCE_COACH_LABEL,
          pathName: PageNames.CAREER_MANAGER,
        },
        {
          name: `${careerManagerSurname} ${careerManagerName}`,
          pathName: `${PageNames.CAREER_MANAGER}/${careerManagerId}?${DETAIL_QUERY_PARAM_KEY}=${encodeParams(
            {
              careerManagerName: careerManagerName ?? "",
              careerManagerSurname: careerManagerSurname ?? "",
            },
          )}`,
        },
        {
          name: `${collaboratorSurname} ${collaboratorName}`,
          pathName: null,
        },
      ];
    } else if (pathname.includes(PageNames.MANAGEMENT)) {
      return [
        {
          name: MANAGEMENT_LABEL,
          pathName: PageNames.MANAGEMENT,
        },
        {
          name: `${collaboratorSurname} ${collaboratorName}`,
          pathName: `${PageNames.MANAGEMENT}/collaborators/${collaboratorId}`,
        },
      ];
    } else {
      return [
        {
          name: COLLABORATORS_LABEL,
          pathName: PageNames.COLLABORATORS,
        },
        {
          name: `${collaboratorSurname} ${collaboratorName}`,
          pathName: null,
        },
      ];
    }
  };
  useBreadCrumb(getBreadcrumbItems());

  return <CollaboratorProfileTabs />;
};

export default CollaboratorDetail;
